import React from 'react';
import line_with_dot from '../../assets/line_with_dot.svg';

import './date.css';

export default function Date({ date, isJobInDate }) {

  let dateStyle;

  if (!isJobInDate) {
    dateStyle = {
      opacity: "0.2"
    }
  }

  return (
    <div className="date">
      <p className="text-left mb-0 ml-4 text-dark" style={dateStyle}>{date}</p>
      <img src={line_with_dot} alt="line" className="img img-fluid" style={dateStyle} />
    </div>
  )
}
